import { render, staticRenderFns } from "./page-music.vue?vue&type=template&id=14faf4e0&"
import script from "./page-music.vue?vue&type=script&lang=ts&"
export * from "./page-music.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports